export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6916.83afe8f3.jpg";